import QRCode from "qrcode";
import { useEffect, useState } from "react";

/** Data URL for a QR code of the given text, or "" while generating. Pass "" to skip (popup closed). */
const useQrCodeDataUrl = (text: string, width: number): string => {
    const [qrDataUrl, setQrDataUrl] = useState("");

    useEffect(() => {
        if (!text) {
            setQrDataUrl("");
            return;
        }

        let cancelled = false;
        QRCode.toDataURL(text, { width, margin: 1 })
            .then((url: string) => {
                if (!cancelled) setQrDataUrl(url);
            })
            .catch(() => {});

        return () => {
            cancelled = true;
        };
    }, [text, width]);

    return qrDataUrl;
};

export default useQrCodeDataUrl;
